import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { finalize } from 'rxjs';

import { AuthService } from '../../../core/auth/auth.service';
import { httpErrorMessage } from '../../../core/utils/http-error-message';

@Component({
  selector: 'app-admin-login',
  standalone: true,
  imports: [FormsModule, RouterLink],
  templateUrl: './admin-login.html',
  styleUrl: './admin-login.scss',
})
export class AdminLogin {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly route = inject(ActivatedRoute);

  credentials = {
    emailOrUserName: this.route.snapshot.queryParamMap.get('email') ?? '',
    password: '',
  };

  isSubmitting = false;
  errorMessage = '';
  readonly resetMessage = this.route.snapshot.queryParamMap.get('reset') === '1'
    ? 'Password updated successfully. Sign in with your new password.'
    : '';

  onSubmit(): void {
    if (this.isSubmitting) {
      return;
    }

    this.errorMessage = '';

    const emailOrUserName = this.credentials.emailOrUserName.trim();
    const password = this.credentials.password.trim();

    if (!emailOrUserName || !password) {
      this.errorMessage = 'Email or username and password are required.';
      this.cdr.detectChanges();
      return;
    }

    this.isSubmitting = true;
    this.cdr.detectChanges();

    console.time('Admin Login API');

    this.auth
      .platformLogin({
        emailOrUserName,
        password,
        ipAddress: null,
        userAgent: navigator.userAgent,
      })
      .pipe(
        finalize(() => {
          console.timeEnd('Admin Login API');
          this.isSubmitting = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: (response) => {
          void this.router.navigate([response.user.mustChangePassword ? '/change-password' : '/admin/dashboard']);
        },
        error: (error: unknown) => {
          console.log('Admin Login Error:', error);

          this.errorMessage = httpErrorMessage(
            error,
            'Unable to sign in. Use a superadmin or developer support account.'
          );

          this.cdr.detectChanges();
        },
      });
  }
}
